/* @flow */
import * as React from 'react';

import Checkbox from 'components/Checkbox';
import type { Props as CheckboxProps } from 'components/Checkbox';
import UserAvatar from 'users/components/UserAvatar';
import type { Props as UserAvatarProps } from 'users/components/UserAvatar';

import getField from '../ComposableTableField';
import type { Field } from '../ComposableTableField';

import './ComposableTable-UserAvatarCheckboxCell.scss';

export function getUserAvatarCheckboxCellGenerator(input: {
  checkboxProps?: $Shape<CheckboxProps>,
  checked: any => boolean,
  fieldForAction?: Field,
  hideAvatar?: boolean,
  onAvatarClickAction: (SyntheticEvent<>, any) => void,
  onCheckboxClickAction: (SyntheticEvent<>, any) => void,
  userAvatarProps?: $Shape<UserAvatarProps>,
  userField?: Field,
}) {
  return (data: Object) => {
    return (
      <div className="ComposableTable-UserAvatarCheckboxCell">
        <Checkbox
          {...input.checkboxProps}
          checked={input.checked(getField(data, input.fieldForAction))}
          readOnly
          className="ComposableTable-UserAvatarCheckboxCell-checkbox"
          onClick={event =>
            input.onCheckboxClickAction(event, getField(data, input.fieldForAction))
          }
        />
        {!input.hideAvatar && (
          <UserAvatar
            {...input.userAvatarProps}
            user={getField(data, input.userField)}
            size="medium"
            className="ComposableTable-UserAvatarCheckboxCell-avatar"
            onClick={e => input.onAvatarClickAction(e, getField(data, input.fieldForAction))}
          />
        )}
      </div>
    );
  };
}
